import { motion } from 'framer-motion'
import { deviceColors } from './chartColors'
import type { AnalyticsData } from './types'

interface ClientBreakdownProps {
  analyticsData: AnalyticsData
}

export default function ClientBreakdown({
  analyticsData,
}: ClientBreakdownProps) {
  return (
    <>
      {/* 상세 분석 섹션 */}
      <div className="mb-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {/* 브라우저 분석 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.8 }}
          className="rounded-lg bg-white p-6 shadow dark:bg-gray-800"
        >
          <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
            브라우저 분석
          </h3>
          <div className="space-y-3">
            {analyticsData.browserStats?.slice(0, 5).map((browser, index) => (
              <div
                key={browser.browser}
                className="flex items-center justify-between"
              >
                <div className="flex items-center">
                  <div
                    className="mr-3 h-3 w-3 rounded-full"
                    style={{
                      backgroundColor:
                        deviceColors[index % deviceColors.length],
                    }}
                  ></div>
                  <span className="text-sm text-gray-900 dark:text-white">
                    {browser.browser}
                  </span>
                </div>
                <div className="text-right">
                  <div className="text-sm font-medium text-gray-900 dark:text-white">
                    {browser.count.toLocaleString()}
                  </div>
                  <div className="text-xs text-gray-500">
                    {browser.percentage}%
                  </div>
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        {/* OS 분석 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.9 }}
          className="rounded-lg bg-white p-6 shadow dark:bg-gray-800"
        >
          <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
            운영체제 분석
          </h3>
          <div className="space-y-3">
            {analyticsData.osStats?.slice(0, 5).map((os, index) => (
              <div key={os.os} className="flex items-center justify-between">
                <div className="flex items-center">
                  <div
                    className="mr-3 h-3 w-3 rounded-full"
                    style={{
                      backgroundColor:
                        deviceColors[index % deviceColors.length],
                    }}
                  ></div>
                  <span className="text-sm text-gray-900 dark:text-white">
                    {os.os}
                  </span>
                </div>
                <div className="text-right">
                  <div className="text-sm font-medium text-gray-900 dark:text-white">
                    {os.count.toLocaleString()}
                  </div>
                  <div className="text-xs text-gray-500">{os.percentage}%</div>
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        {/* 소셜 네트워크 분석 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1.0 }}
          className="rounded-lg bg-white p-6 shadow dark:bg-gray-800"
        >
          <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
            소셜 미디어 유입
          </h3>
          <div className="space-y-3">
            {analyticsData.socialNetworkStats?.map((social, index) => (
              <div
                key={social.socialNetwork}
                className="flex items-center justify-between"
              >
                <div className="flex items-center">
                  <div
                    className="mr-3 h-3 w-3 rounded-full"
                    style={{
                      backgroundColor:
                        deviceColors[index % deviceColors.length],
                    }}
                  ></div>
                  <span className="text-sm capitalize text-gray-900 dark:text-white">
                    {social.socialNetwork}
                  </span>
                </div>
                <div className="text-sm font-medium text-gray-900 dark:text-white">
                  {social.count.toLocaleString()}
                </div>
              </div>
            ))}
            {(!analyticsData.socialNetworkStats ||
              analyticsData.socialNetworkStats.length === 0) && (
              <div className="py-4 text-center text-gray-500">
                소셜 미디어 유입 데이터가 없습니다
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </>
  )
}
